module.exports = __webpack_public_path__ + "img/_Panchito.e22544e2.png";